/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InvalidTools } from '../models/InvalidTools';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InvalidToolsService {
    /**
     * list invalid tools
     * @returns InvalidTools successful
     * @throws ApiError
     */
    public static getInvalidTools(): CancelablePromise<InvalidTools> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/health_board/invalid_tools',
        });
    }
}
